/* Spacing variables we use in CSS */
export const VERY_THIN_SPACING = 4;
export const THIN_SPACING = 8;
export const SMALL_SPACING = 12;
export const MEDIUM_SPACING = 16;
export const THICK_SPACING = 24;
export const VERY_THICK_SPACING = 36;
